Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    timePickerPopoverElevation: 70,
    timePickerPopoverBackgroundColor: tokens.themeBackgroundPrimaryDefault,
    timePickerPopoverBorderWidth: 1,
    timePickerPopoverBorderRadius: 4,
    timePickerPopoverBorderColor: tokens.themeBorderPrimaryDefault,
    timePickerPopoverDropShadowOffsetX: 0,
    timePickerPopoverDropShadowOffsetY: 2,
    timePickerPopoverDropShadowBlur: 4,
    timePickerPopoverDropShadowSpread: 0,
    timePickerPopoverDropShadowColor: "rgba(11, 12, 12, 0.16)",
    timePickerPopoverSpacingVertical: 8,
    timePickerOptionsBorderRadius: 4,
    timePickerOptionsSpacingVertical: 4,
    timePickerOptionsSpacingHorizontal: 2,
    timePickerErrorTooltipElevation: 80,
    timePickerInputValueLetterSpacing: 2,
    timePickerInputPlaceholderFontSize: 13,
    timePickerInputPlaceholderLineHeight: "18px",
    timePickerInputPlaceholderColorDefault: tokens.themeForegroundSecondaryDefault,
    timePickerInputPlaceholderColorDisabled: tokens.themeForegroundPrimaryDisabled
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/meridian-tokens/component/time-picker.js
// module id = 250
// module chunks = 0